import React from 'react';
import Icon from '../../../components/AppIcon';

const SettlementStatusPanel = ({ statusData }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return { bg: 'bg-success/10', text: 'text-success', icon: 'CheckCircle' };
      case 'pending':
        return { bg: 'bg-warning/10', text: 'text-warning', icon: 'Clock' };
      case 'failed':
        return { bg: 'bg-error/10', text: 'text-error', icon: 'XCircle' };
      default:
        return { bg: 'bg-muted', text: 'text-muted-foreground', icon: 'HelpCircle' };
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-elevation-1">
      <h2 className="text-lg md:text-xl font-semibold text-foreground mb-6">Status Settlement</h2>
      <div className="space-y-4">
        {statusData?.map((item) => {
          const colors = getStatusColor(item?.status);
          return (
            <div key={item?.status} className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-smooth">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-lg ${colors?.bg} flex items-center justify-center`}>
                    <Icon name={colors?.icon} size={20} className={colors?.text} />
                  </div>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground capitalize">{item?.label}</h3>
                    <p className="text-xs text-muted-foreground">{item?.avgTime}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl md:text-2xl font-bold text-foreground data-text">{item?.count}</p>
                  <p className="text-xs text-muted-foreground">{item?.percentage}%</p>
                </div>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className={`h-2 rounded-full ${colors?.bg?.replace('/10', '')}`}
                  style={{ width: `${item?.percentage}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Total Settlement</span>
          <span className="text-lg font-bold text-foreground data-text">
            {statusData?.reduce((acc, item) => acc + item?.count, 0)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SettlementStatusPanel;